





























import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'

@Component({
})
export default class AppCheckbox extends Vue {
  @Prop() readonly value!: boolean
  @Prop({ default: false }) readonly disabled!: boolean
  @Prop() readonly label!: string

  @Emit('input')
  switchValue (e: MouseEvent) {
    e.preventDefault()
    e.stopPropagation()
    this.changeValue()
    return !this.value
  }

  @Emit('change')
  changeValue () {
    return !this.value
  }
}
